import React from 'react'
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'
import App from 'app/components/containers/App'
import LoginPage from 'app/components/login/LoginPage'
import SignupPage from 'app/components/signup/SignupPage'
import VerificationPage from 'app/components/verification/VerificationPage'
import DashboardRoutes from './DashboardRoutes'
import Trips from 'app/components/trips/TripsPage'
import Vehicles from 'app/components/vehicles/VehiclesPage'
import Drivers from 'app/components/drivers/DriversPage'
import { getAccessToken, setAccessToken } from 'app/utils/token'

const routes = [
  {
    path: '/login',
    public: true,
    component: LoginPage,
  },
  {
    path: '/signup',
    public: true,
    component: SignupPage,
  },
  {
    path: '/verification',
    public: true,
    component: VerificationPage,
  },
]

const newProviderRoutes = [
  {
    path: '/v2/trips/:hash?',
    pathTo: '/trips',
    name: 'Trips',
    icon: 'swap_calls',
    component: Trips,
  },
  {
    path: '/v2/drivers',
    pathTo: '/drivers',
    name: 'Drivers',
    icon: 'group',
    component: Drivers,
  },
  {
    path: '/v2/vehicles',
    pathTo: '/vehicles',
    name: 'Vehicles',
    icon: 'directions_car',
    component: Vehicles,
  },
]

const Routes = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const urlToken = urlParams.get('accessToken')
  if (urlToken) {
    setAccessToken(urlToken)
  }

  return (
    <Router>
      <App>
        <Route
          exact
          path="/"
          render={() =>
            getAccessToken() || urlToken ? (
              <Redirect to="/trips" />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
        {routes.map((route, index) => {
          return route.public ? (
            <Route key={index} exact {...route} />
          ) : (
            <PrivateRoute key={index} exact {...route} />
          )
        })}
        {newProviderRoutes.map((route, index) => {
          return route.public ? (
            <Route key={index} exact {...route} />
          ) : (
            <PrivateRoute key={index} exact {...route} />
          )
        })}
        <DashboardRoutes />
        {/* <CookieNotice /> */}
      </App>
    </Router>
  )
}

export default Routes
